import React from "react";
import { Table, Dropdown } from "react-bootstrap";
import { formatCurrencyValue } from "../../../../../utils";
import { searchProducts, getCategories } from "../../../../../api/products";
import Modal from "../../../../../_components/Modal";
import Text from "../../../../../_components/Text";
import Button from "../../../../../_components/Button";
import LoadingInput from "../../../../../_components/LoadingInput";

import Row from "../../../../../_components/Layout/Row";
import Column from "../../../../../_components/Layout/Column";
import { CreateProductContainer } from "../../Product";

export default function FilterProducts(props) {
  const ref = React.useRef(null);
  const [showCreateModal, setShowCreateModal] = React.useState(false)
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [params, setParams] = React.useState({
    end_count: 10,
    is_active: true,
  });

  function onChange(e) {
    setParams({
      ...params,
      [e.target.name]: e.target.value,
    });
  }

  function onSubmit(e) {
    e.preventDefault();
    onSearch();
  }

  function onSearch() {
    setLoading(true);
    searchProducts(params)
      .then((resp) => setData(resp))
      .finally(() => setLoading(false));
  }

  function init() {
    setLoading(true);
    getCategories()
      .then((resp) => setCategories(resp))
      .finally(() => setLoading(false));
  }

  const handleRowClick = (event) => {
    if (event.target.tagName === "TR") {
      props.onRowClick();
    }
  };

  const handleActionClick = (event) => {
    // Stop the propagation of the click event to prevent it from reaching the <tr> click handler
    event.stopPropagation();

    // Handle the action click here
    // ...
  };

  React.useEffect(init, [ref.current]);

  return (
    <form action="" onSubmit={onSubmit} ref={ref}>
      <Row>
        <Column md="4" lg="3" xs="12">
          <div className="form-group">
            <div className="form-label">
              <Text>Código</Text>
            </div>
            <LoadingInput
              data-cy-test="#search-itens-input-code"
              name="code"
              value={params.code}
              loading={loading}
              onChange={onChange}
            />
          </div>
        </Column>
        <Column md="4" lg="3" xs="12">
          <div className="form-group">
            <div className="form-label">
              <Text>Código de barras</Text>
            </div>
            <LoadingInput
              name="barcode"
              loading={loading}
              value={params.barcode}
              onChange={onChange}
            />
          </div>
        </Column>
        <Column md="4" lg="3" xs="12">
          <div className="form-group">
            <div className="form-label">
              <Text>Descrição</Text>
            </div>
            <LoadingInput
              data-cy-test="#search-itens-input-description"
              name="name"
              loading={loading}
              value={params.name}
              onChange={onChange}
            />
          </div>
        </Column>
        <Column md="4" lg="3" xs="12">
          <div className="form-group">
            <div className="form-label">
              <Text>Categorias</Text>
            </div>
            <LoadingInput
              name="categories"
              loading={loading}
              onChange={onChange}
              as="select"
            >
              <option value="">Selecione a categoria</option>
              {categories.map((categorie) => {
                return <option value={categorie.id}>{categorie.name}</option>;
              })}
            </LoadingInput>
          </div>
        </Column>
        <Column md="4" lg="3" xs="12">
          <div className="form-group">
            <div className="form-label">
              <Text>Resultados</Text>
            </div>
            <LoadingInput
              name="end_count"
              loading={loading}
              onChange={onChange}
              as="select"
            >
              <option value="" selected disabled>
                Selecione a quantidade
              </option>
              {[10, 15, 20, 30, 50, 100, 200].map((count) => {
                return (
                  <option selected={count === params.end_count} value={count}>
                    {count}
                  </option>
                );
              })}
            </LoadingInput>
          </div>
        </Column>
      </Row>
      <Row justify="space-between">
        <Column col="auto">
          <Button onClick={onSearch} disabled={loading}>
            Pesquisar
          </Button>
        </Column>
        {props.modalBehavior ?

          <Column col="auto">
            <Button onClick={() => {
              console.log(props)
              setShowCreateModal(true)
            }} disabled={loading}>
              Cadastrar Item
            </Button>
          </Column>

          :

          <React.Fragment></React.Fragment>
        }

      </Row>
      <div className={data.length ? "row" : "d-none"}>
        <div className="col-12">
          <Table>
            <thead>
              <tr>
                {/* <th>#</th> */}
                <th>Cód.</th>
                <th>Descrição</th>
                <th>Uni.</th>
                <th>NCM</th>
                <th>Estoque</th>
                <th>CFOP</th>
                <th>Valor</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {data
                .slice()
                .reverse()
                .map((item, idx) => {
                  if (!item.fiscal_data) {
                    item.fiscal_data = {
                      ncm: {
                        code: "--",
                      },
                      cfop: {
                        code: "--",
                      },
                    };
                  }
                  if (item.stock.quantity) {
                    item.stock_quantity = item.stock.quantity;
                  }
                  return (
                    <tr
                      data-cy-test={`#search-itens-list-result-index=${idx}`}
                      key={`filter-product-${item.id}`}
                      style={{ cursor: "pointer" }}
                    >
                      {/* <td onClick={() => props.onClick(item)} >
                                            {idx + 1}
                                        </td> */}
                      <td onClick={() => props.onClick(item)}>
                        {item.sellable.code}
                      </td>
                      <td onClick={() => props.onClick(item)}>
                        {item.sellable.name}
                      </td>
                      <td onClick={() => props.onClick(item)}>
                        {item.sellable.unit_branch.name}
                      </td>
                      <td onClick={() => props.onClick(item)}>
                        {item.fiscal_data.ncm.code}
                      </td>
                      <td onClick={() => props.onClick(item)}>
                        {item.stock_quantity || 0}
                      </td>
                      <td onClick={() => props.onClick(item)}>
                        {item.fiscal_data.cfop.code}
                      </td>
                      <td onClick={() => props.onClick(item)}>
                        {formatCurrencyValue(item.sellable.price)}
                      </td>
                      <td style={{ zIndex: 99 }}>
                        <Dropdown
                          title="Mais Opções"
                          drop="left"
                          alignRight={true}
                        >
                          <Dropdown.Toggle
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                              padding: "none",
                              marginTop: -8,
                              marginLeft: 10,
                            }}
                          >
                            <i
                              style={{ cursor: "pointer" }}
                              className="fas fa-ellipsis-v text-black-50"
                            />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              onClick={() =>
                                (window.location.href = `/products/create/?suggestion=${item.id}`)
                              }
                            >
                              Duplicar produto
                            </Dropdown.Item>

                            <Dropdown.Divider></Dropdown.Divider>

                            <Dropdown.Item
                              onClick={() =>
                                (window.location.href = `/product/${item.id}`)
                              }
                            >
                              Editar produto
                            </Dropdown.Item>

                          </Dropdown.Menu>
                          
                        </Dropdown>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        </div>
      </div>

      <Modal onHide={() => setShowCreateModal(false)} show={showCreateModal}>
        <CreateProductContainer closeIt={() => setShowCreateModal(false)} />
      </Modal>

    </form>
  );
}



// WEBPACK FOOTER //
// ./src/views/AppViews/Products/components/Filter/index.jsx